<template>
    <div class="mapCenter">
        <mapTools ref="mapTools" @clearImgsId="clearImgsId" @parentData="parentDatafn" v-if="mapBase ? true : false"
            :mapobj="mapBase" :mapqueryList="mapType"></mapTools>
        <div class="productMapWrap" id="productMap" ref="themap"></div>
    </div>
</template>
  
<script>
import Status from "@/utils/Status";
import mapTools from "./mapTools.vue";
import WKTToGeoJson from "@/utils/WKTToGeoJson";
import mapFunctions from '@/utils/mapFun.js'
// 地图服务地址
var mapUrl = window.dataManage.mapServerUrl;
var mapToken = window.dataManage.mapServerKey;
export default {
    name: "mapCenter",
    data() {
        return {
            mapBase: null,
            mapType: [],
            theInterval: null,
            imageSourceIds: []
        };
    },
    components: {
        mapTools
    },
    props: {
        clearMapTool: {
            type: String,
            default: ''
        },
        searchChange: {
            type: String,
            default: ''
        }
    },
    watch: {
        searchChange: {
            deep: true,//深度监听设置为 true
            handler: function (newVal, oldVal) {
                if (newVal) {
                    console.log(newVal);
                    console.log('搜索绘制要清除了！');
                    this.clearSearchImgsId();
                }

            }
        },
        clearMapTool: {
            deep: true,//深度监听设置为 true
            handler: function (newVal, oldVal) {
                if (newVal) {
                    console.log(newVal);
                    console.log('地图工具绘制要清除了！');
                    this.clearImgsId('123');
                }

            }
        },
        "$store.state.productSearch.imageInfo": {
            deep: true,//深度监听设置为 true
            handler: function (newVal, oldVal) {
                console.log("地图绘制影像数据发生变化啦"); //修改数据时，能看到输出结果
                // 先清空销毁图像残留
                if (this.imageSourceIds.length > 0) {
                    if (this.mapBase) {
                        this.mapBase.flyTo({
                            center: [102, 37.94],
                            zoom: 3,
                        });
                    }
                    console.log('绘制过的图像集合：', this.imageSourceIds);
                    this.clearImgsId();
                }
                setTimeout(item => {
                    // console.log('即将绘制的数据：', newVal);
                    this.addImageBorder(newVal);
                    // if (newVal.length > 0) {
                    //     newVal.map(items => {
                    //         // 添加图像
                    //         this.addImageToMap(items);
                    //     })
                    // }
                }, 200)
            }
        },
        "$store.state.productSearch.imageSwitchInfo": {
            deep: true,//深度监听设置为 true
            handler: function (newVal, oldVal) {
                let acceptVal = newVal.goodsInfo;
                // 定位中心点
                let changeCoord = WKTToGeoJson(acceptVal.coordinateInfo);
                let firstArray = Array.prototype.slice.call(changeCoord.coordinates[0][0]);
                let sendArray = Array.prototype.slice.call(changeCoord.coordinates[0]);
                sendArray.push(firstArray);
                let acceptCoordsCenter = mapFunctions.calculateCenter(sendArray)
                // 接口无中标返回
                console.log('中心点坐标返回：', acceptCoordsCenter);
                this.mapBase.flyTo({
                    center: [acceptCoordsCenter.lng, acceptCoordsCenter.lat],
                    zoom: 3,
                });
                console.log('结果图像被点击了:', acceptVal);
                if (this.imageSourceIds.length > 0) {
                    let indexFind = this.imageSourceIds.indexOf(acceptVal.goodsId);
                    if (indexFind > 0 || indexFind == 0) {
                        console.log('已存在', indexFind, acceptVal.goodsId, this.imageSourceIds);
                        this.imageSourceIds.splice(indexFind, 1);
                        this.removeLayerById(acceptVal.goodsId);
                    } else {
                        console.log('不存在');
                        this.addSingleImageToMap(acceptVal);
                    }
                } else {
                    this.addSingleImageToMap(acceptVal);
                }

            }
        }
    },
    mounted() {
        // 初始化地图
        this.initMap();
    },
    beforeDestroy() {
        // 销毁定时器
        if (this.theInterval) clearInterval(this.theInterval);
        // 销毁图像残留
        this.imageSourceIds.forEach((id) => {
            this.removeLayerById(id);
        });
    },
    methods: {
        // 地图工具触发查询参数接受
        parentDatafn(param) {
            console.log("触发查询参数接受:", param);
            this.searchResultToolValue = !this.searchResultToolValue;
            this.seachParamsJson = param.wkt;
            this.$store.dispatch('productSearch/updateToolInfo', this.seachParamsJson)
        },
        initMap() {
            let that = this;
            this.mapBase = new mapboxgl.Map({
                container: "productMap",
                // scrollZoom: false,
                // boxZoom: false,
                // doubleClickZoom: false,
                style: {
                    version: 8,
                    sources: {
                        // "google.tile": {
                        //   type: "raster",
                        //   tiles: [mapUrl],
                        //   tileSize: 256,
                        // },
                    },
                    layers: [
                        // {
                        //   id: "google",
                        //   type: "raster",
                        //   source: "google.tile",
                        // },
                    ],
                },
                center: [102, 37.94], // starting position [lng, lat]
                zoom: 3, // starting zoom
                minZoom: 3,
            });
            this.mapBase.on("load", () => {
                this.mapBase.addSource("google.tile", {
                    type: "raster",
                    tiles: [mapUrl + mapToken],
                    tileSize: 256,
                });
                this.mapBase.addLayer({
                    id: "google",
                    type: "raster",
                    source: "google.tile",
                });
                this.theInterval = setInterval(() => {
                    this.mapBase.resize();
                }, 100);
            });
            // console.log(this.mapBase);
            let state = new Status(this.mapBase, 0, 0, false); //显示左下角scale与center
            document.getElementById("productMap").appendChild(state.dom); //Status模块插入dom树
            setTimeout(function () {
                that.$emit("ismapcompelate", that.mapBase);
            }, 80)

        },
        addImageToMap(itemObj) {
            const id = itemObj.id;
            // 添加图像id并存储
            this.clearLayer(id);
            this.mapBase.addLayer({
                id,
                source: {
                    type: "image",
                    url: itemObj.image, //itemObj.quickView,
                    coordinates: itemObj.coordinates[0],
                },
                type: "raster",
                paint: { "raster-opacity": 0.85 },
            });
            this.imageSourceIds.push(id);
            // this.addImageBorder(itemObj);
            // console.log('图像添加完毕！当前存储的图像id：', this.imageSourceIds);
        },
        // 添加单一图像到地图
        addSingleImageToMap(val) {
            console.log('添加单一图像信息：', val);
            const id = val.goodsId;
            // 已存在图像则移除
            // this.removeLayerById(val.goodsId);
            let changeCoord = WKTToGeoJson(val.coordinateInfo);
            console.log('转换后的图像坐标：', changeCoord);
            this.mapBase.addLayer({
                id,
                source: {
                    type: "image",
                    url: val.goodsThumbnail, //itemObj.quickView,
                    coordinates: changeCoord.coordinates[0],
                },
                type: "raster",
                paint: { "raster-opacity": 0.85 },
            });
           
            this.imageSourceIds.push(id);
        },
        addImageBorder(allCoordinates) {
            this.removeLayerById("bigerlayer");
            // console.log('绘制多边形数据：',allCoordinates);
            let madeArray = [];
            allCoordinates.map(item => {
                // item.coordinates[0].push(copyItem);
                // console.log(copyItem);
                let firstArray = Array.prototype.slice.call(item.coordinates[0][0]);
                let sendArray = Array.prototype.slice.call(item.coordinates[0]);
                sendArray.push(firstArray)
                let madeJson = {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [sendArray]
                    },
                    "type": "Feature"
                };
                madeArray.push(madeJson)
            })
            // console.log('绘制可制作的多边形参数：',madeArray);
            setTimeout(item => {
                this.mapBase.addLayer({
                    id: "bigerlayer",
                    type: "line", //line
                    source: {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: madeArray
                        },
                    },
                    layout: {},
                    paint: {
                        "line-color": "red",
                        "line-width": 2,
                        // 'fline-width':2,
                        // 'fill-color': '#000',//地块填充颜色
                        // 'fill-outline-color': 'red',//边框颜色
                        // 'fill-opacity': 0.5//透明度
                    },
                });

            }, 1000)

        },
        // 搜索触发清除
        clearSearchImgsId() {
            this.removeLayerById("buffer");
            this.removeLayerById("lineK");
            this.removeLayerById("overlay");
            this.removeLayerById("uploadLayerId");
            this.removeLayerById("bigerlayer");
            if (this.imageSourceIds.length > 0) {
                this.imageSourceIds.forEach(item => {
                    this.removeLayerById(item)
                })
            }
        },
        // 地图工具全部清除/清除图像id
        clearImgsId(e) {
            console.log('地图工具发出清除数据', e);
            if (this.mapBase) {
                this.mapBase.flyTo({
                    center: [102, 37.94],
                    zoom: 3,
                });
            }
            this.removeLayerById("bigerlayer");
            // console.log('绘制过的图像集合并且要清除的：', this.imageSourceIds);
            if (e && e !== '123') {
                // 工具绘制触发 清除工具绘制边框等
                this.removeLayerById("buffer");
                this.removeLayerById("lineK");
                this.removeLayerById("overlay");
                this.removeLayerById("uploadLayerId");
            }
            if (this.imageSourceIds.length > 0) {
                this.imageSourceIds.forEach(item => {
                    this.removeLayerById(item)
                })
            }
        },
        // 清除图层
        clearLayer(layerId) {
            // console.log('要清除的图像id：', layerId);
            let findIndex = -1;
            this.imageSourceIds.forEach((item, index) => {
                if (item == layerId) {
                    // 如果有对的上的话  把index
                    findIndex = index;
                }
            });
            if (findIndex >= 0) {
                this.removeLayerById(layerId);
                this.imageSourceIds.splice(findIndex, 1);
                return;
            }
            // console.log('图像清除完毕！剩余图像数据：', this.imageSourceIds);
        },
        removeLayerById(layerId) {
            if (this.mapBase.getLayer(layerId)) {
                this.mapBase.removeLayer(layerId);
                if (this.mapBase.getSource(layerId)) this.mapBase.removeSource(layerId);
            }
        },
    },
};
</script>
  
<style lang="scss" scoped>
.mapBox {
    width: 100%;
    height: 100vh;
    min-width: 1000px;
    background-color: rgb(192, 192, 192);
    position: relative;
    overflow: hidden;

    .productMapWrap {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
}
</style>
  